// extracted by mini-css-extract-plugin
export default {"root":"kEwhT0Fz","single":"txAd3pUL","multiple":"WR3ZgAiS","largeDonut":"gtY1HsT0"};